<template>
  <div>
    <div class="d-flex align-center">
      <div class="flex-1 gray--text text-5 font-weight-medium">TX TYPE:</div>
      <div class="flex-2 text-3">
        Approve {{ info.token | uppercase }} Spend Limit
      </div>
    </div>
    <div class="d-flex align-center mt-3">
      <div class="flex-1 gray--text text-5 font-weight-medium">VAULT:</div>
      <div class="flex-2 text-3">
        Vaults-{{ vaultNameMap[info.vault] }}
      </div>
    </div>
    <div class="d-flex align-center mt-3">
      <div class="flex-1 gray--text text-5 font-weight-medium">STRATEGY:</div>
      <div class="flex-2 text-3">{{ info.strategy }}</div>
    </div>
    <div class="d-flex align-center mt-3">
      <div class="flex-1 gray--text text-5 font-weight-medium">AMOUNT:</div>
      <div class="flex-2 text-3" v-if="info.approvalRequired">
        {{ info.approvalAmount | denomFormat }} {{ info.token | uppercase }}
      </div>
      <div class="flex-2 text-3" v-else>
        {{ info.amount | denomFormat }} {{ info.token | uppercase }}
      </div>
    </div>
  </div>
</template>

<script>
import AppConst from "@/common/constants";

export default {
  props: ["info"],
  computed: {
    vaultNameMap: () => AppConst.VAULT_MAP,
  },
};
</script>
